"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _Collapsible = _interopRequireDefault(require("./Collapsible.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Collapsible = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Collapsible, _React$PureComponent);
  var _super = _createSuper(Collapsible);
  function Collapsible(props) {
    var _this;
    _classCallCheck(this, Collapsible);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "closeCollapsible", function () {
      _this.setState({
        height: _this.contentWrapperRef.current.offsetHeight,
        transition: "height ".concat(_this.props.transitionTime, "ms ").concat(_this.props.easing),
        overflow: 'hidden',
        shouldSwitchAutoOnNextCycle: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "openCollapsible", function () {
      _this.setState({
        shouldOpenOnNextCycle: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "continueOpenCollapsible", function () {
      _this.setState({
        height: _this.contentWrapperRef.current.offsetHeight,
        transition: "height ".concat(_this.props.transitionTime, "ms ").concat(_this.props.easing),
        isClosed: false,
        overflow: 'hidden',
        shouldOpenOnNextCycle: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      event.preventDefault();
      if (_this.props.disabledCollapse) return;
      if (_this.state.isClosed === true) {
        _this.openCollapsible();
        if (_this.props.onOpen) _this.props.onOpen();
      } else {
        _this.closeCollapsible();
        if (_this.props.onClose) _this.props.onClose();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleTransitionEnd", function () {
      if (!_this.state.isClosed) {
        _this.setState({
          height: 'auto',
          overflow: 'visible'
        });
        if (_this.props.onOpen) _this.props.onOpen();
      } else if (_this.props.onClose) _this.props.onClose();
    });
    _defineProperty(_assertThisInitialized(_this), "contentWrapperRef", null);
    _this.contentWrapperRef = /*#__PURE__*/_react["default"].createRef();
    if (props.isOpen) {
      _this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: 'auto',
        transition: 'none',
        overflow: 'visible'
      };
    } else {
      _this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: "height ".concat(props.transitionTime, "ms ").concat(props.easing),
        overflow: 'hidden'
      };
    }
    return _this;
  }
  _createClass(Collapsible, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;
      if (this.state.shouldOpenOnNextCycle) {
        this.continueOpenCollapsible();
      }
      if (prevState.height === 'auto' && this.state.shouldSwitchAutoOnNextCycle === true) {
        setTimeout(function () {
          _this2.setState({
            height: 0,
            isClosed: true,
            shouldSwitchAutoOnNextCycle: false,
            overflow: 'hidden'
          });
        }, 50);
      }
      if (prevProps.isOpen !== this.props.isOpen) {
        if (this.props.isOpen === true) {
          this.openCollapsible();
          if (this.props.onOpen) this.props.onOpen();
        } else {
          this.closeCollapsible();
          this.props.onClose();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        trigger = _this$props.trigger;
      var contentWrapperStyle = {
        height: this.state.height,
        maxHeight: this.setState.maxHeight,
        transition: this.state.transition,
        overflow: this.state.overflow
      };
      return /*#__PURE__*/_react["default"].createElement(_Collapsible["default"], {
        className: "".concat(className, " ").concat(this.state.isClosed ? 'collapsed' : 'expanded')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(className, "-trigger"),
        onClick: function onClick(event) {
          _this3.handleClick(event);
        },
        onKeyDown: function onKeyDown(event) {
          _this3.handleClick(event);
        },
        role: "link",
        tabIndex: "0"
      }, trigger), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(className, "-content"),
        style: contentWrapperStyle,
        onTransitionEnd: this.handleTransitionEnd
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "content-wrapper",
        ref: this.contentWrapperRef
      }, children)));
    }
  }]);
  return Collapsible;
}(_react["default"].PureComponent);
Collapsible.defaultProps = {
  className: 'collapsible',
  disabledCollapse: false,
  isOpen: true,
  onClose: undefined,
  onOpen: undefined,
  transitionTime: 400,
  easing: 'ease-in-out'
};
Collapsible.propTypes = {
  /** Text or html to be displayed inside the collapsible element */
  children: _propTypes["default"].node.isRequired,
  /** The CSS class name of the wrapper element. */
  className: _propTypes["default"].string,
  /** The transition animation easing for expanding or collapsing. */
  easing: _propTypes["default"].string,
  /** Flag to indicate if clicking on the trigger should be disabled */
  disabledCollapse: _propTypes["default"].bool,
  /** External prop to indicate if the component should be opened or closed. */
  isOpen: _propTypes["default"].bool,
  /** Action to trigger when closing the collapsible tab */
  onClose: _propTypes["default"].func,
  /** Action to trigger when opening the collapsible tab */
  onOpen: _propTypes["default"].func,
  /** The collapsible section title. Usually a CollabibleTrigger component */
  trigger: _propTypes["default"].node.isRequired,
  /** Time in ms for the expand/collapse transitions to complete */
  transitionTime: _propTypes["default"].number
};
Collapsible.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "closeCollapsible",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "openCollapsible",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "continueOpenCollapsible",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleTransitionEnd",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Collapsible",
  "props": {
    "className": {
      "defaultValue": {
        "value": "'collapsible'",
        "computed": false
      },
      "description": "The CSS class name of the wrapper element.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabledCollapse": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate if clicking on the trigger should be disabled",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isOpen": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "External prop to indicate if the component should be opened or closed.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onClose": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Action to trigger when closing the collapsible tab",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onOpen": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Action to trigger when opening the collapsible tab",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "transitionTime": {
      "defaultValue": {
        "value": "400",
        "computed": false
      },
      "description": "Time in ms for the expand/collapse transitions to complete",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "easing": {
      "defaultValue": {
        "value": "'ease-in-out'",
        "computed": false
      },
      "description": "The transition animation easing for expanding or collapsing.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "Text or html to be displayed inside the collapsible element",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "trigger": {
      "description": "The collapsible section title. Usually a CollabibleTrigger component",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};
var _default = (0, _utils.withDeprecationNotice)(Collapsible, 'Collapsible is deprecated. Please use Collapse.jsx');
exports["default"] = _default;